import React from "react";
import classes from "./WhoWeAre.module.scss";

export interface ITechnicalExpertiseContentBlock {
  title: string;
  image: string;
  list: any;
}

const TechnicalExpertise: React.FC<{
  title: string;
  contentBlocks: ITechnicalExpertiseContentBlock[];
}> = ({ title, contentBlocks }) => {
  return (
    <div className={classes["technical-expertise-container"]}>
      <h2 className={classes.title}>{title}</h2>
      <div className={classes["content-container"]}>
        {contentBlocks.map((block) => (
          <div className={classes["content-block"]} key={block.title}>
            <div className={classes["text-block"]}>
              <h3 className={classes.title}>{block.title}</h3>
              <ul className={classes.list}>
                {block.list.map((text) => (
                  <li key={text}>{text}</li>
                ))}
              </ul>
            </div>
            <div className={classes.img}>
              <img src={block.image} alt={block.title} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechnicalExpertise;
